import { Globe } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguageContext } from "@/contexts/LanguageContext";
import type { Locale } from "@/i18n";

const TARGET: Record<Locale, Locale> = { fr: "ar", ar: "fr" };
const LABEL: Record<Locale, string> = { fr: "FR", ar: "AR" };

export function LanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale } = useLanguageContext();
  const location = useLocation();
  const navigate = useNavigate();

  const target = TARGET[locale];

  const handleSwitch = () => {
    setLocale(target);
    const newPath = location.pathname.replace(
      /^\/(fr|ar)(\/|$)/,
      `/${target}$2`
    );
    const finalPath = newPath.startsWith(`/${target}`)
      ? newPath
      : `/${target}`;
    navigate(finalPath + location.search + location.hash, { replace: true });
  };

  return (
    <button
      onClick={handleSwitch}
      dir="ltr"
      aria-label={locale === "fr" ? "Passer en arabe" : "Passer en français"}
      className={[
        "group flex items-center gap-1.5 shrink-0",
        "h-8 rounded-xl border border-border/60 bg-card px-2.5",
        "shadow-warm-sm transition-all duration-200",
        "hover:border-primary/50 hover:shadow-warm-md hover:bg-primary/5",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40",
        className ?? "",
      ].join(" ")}
    >
      <Globe className="h-3.5 w-3.5 text-muted-foreground transition-colors group-hover:text-primary" />
      <span className="text-[11px] font-bold tracking-wider uppercase leading-none text-foreground transition-colors group-hover:text-primary w-5 text-center" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
        {LABEL[target]}
      </span>
    </button>
  );
}
